import { oz } from '@weft/utils';
import { CHANNEL_TYPE } from './channel-type-schema';

export const ClientChannelSchema = oz.object({
  type: oz.literal(CHANNEL_TYPE.Client),
}).openapi('ClientChannel');

export type ClientChannel = oz.infer<typeof ClientChannelSchema>;